(ns dashboard.components.paginated-list.subs
  (:require [re-frame.core :as rf]))

(rf/reg-sub
 ::view-options-data
 (fn [db [_ view-config-path]]
   (get-in db view-config-path)))

(rf/reg-sub
 ::view-options
 (fn [[_ view-config-path]]
   (rf/subscribe [::view-options-data view-config-path]))
 (fn [view-options [_ _ default-options]]
   (if default-options
     (merge default-options view-options)
     view-options)))
